// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1469":"787c87a43e3a2d3b","5641":"7e64cd9e661d062a","8051":"40a51d0c3f40a889","8469":"c25c21d10a8bb797","9311":"feb09c3b83c61ab7"}[chunkId] + "-1748587329625.css";
};